

























































































import {Component} from "vue-property-decorator";
import routenames from "@/modules/vRoutedefs";
import CommonBase from "../../CommonBase";
import InfoBtn from "../../shared/InfoBtn.vue";
import InfoDialog from "../../InfoDialog.vue";
import LocationInfoText from "@/components/docs/intro/LocationInfoText.vue";
import {CanonicalHost} from "@/modules/constants";

@Component({
    components: {
        "at-info-btn": InfoBtn,
        "at-info-dialog": InfoDialog,
        "at-location-info-text": LocationInfoText,
    }
})
export default class Intro1 extends CommonBase {
    rn = routenames;

    readonly canonicalHost = CanonicalHost;

    showInfo = false;
}
